import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Form, Message } from 'semantic-ui-react';
import { getNumberOfGuestsOptions, getValidationMessage, requestReservation, stringifyReservationDate, getDefaultReservationDate, getDefaultReservationMaxDate } from './ReservationForm.utils';
import ReservationTimeSelect from './components/ReservationTimeSelect';
import Phone from '../../../components/Phone';
import PhoneInput from '../../../components/PhoneInput';
import ReSubmitRecaptchaForm from '../../../components/ReSubmitRecaptchaForm';
import { ActionName } from '../../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { BusinessPropType, LocationPropType } from '../../../services/proptypes';
import LocationsSelect from '../../locations/LocationsSelect/LocationsSelect';
import { getPrimaryLocation } from '../../locations/LocationsSelect/LocationsSelect.utils';
import './ReservationForm.css';
var defaultProps = {
  destinationEmail: '',
  locations: [],
  hideRecaptchaNotice: false
};
var ReservationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ReservationForm, _React$Component);
  var _super = _createSuper(ReservationForm);
  function ReservationForm(props) {
    var _this;
    _classCallCheck(this, ReservationForm);
    _this = _super.call(this, props);
    var locations = props.locations;
    var primaryLocation = getPrimaryLocation(locations);
    var timezone = primaryLocation.timezone,
      id = primaryLocation._id;
    var reservationDate = getDefaultReservationDate(timezone);
    _this.state = {
      formData: {
        location: id,
        reservationDate: reservationDate
      },
      message: '',
      error: false
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ReservationForm, [{
    key: "onChange",
    value: function onChange(e, _ref) {
      var name = _ref.name,
        value = _ref.value;
      this.setState(function (prevState) {
        return {
          formData: _objectSpread(_objectSpread({}, prevState.formData), {}, _defineProperty({}, name, value))
        };
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, recaptchaToken) {
        var formData, validationMessage, _this$props, _this$props$business, businessId, businessType, destinationEmail, locationId, email, firstName, lastName, phone, guestsNumber, comments, reservationDate, reservationTime, payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = this.state.formData;
              validationMessage = getValidationMessage(formData);
              if (!validationMessage) {
                _context.next = 5;
                break;
              }
              this.displayMessage(validationMessage, true, {
                clearTimeout: false
              });
              return _context.abrupt("return");
            case 5:
              _context.prev = 5;
              _this$props = this.props, _this$props$business = _this$props.business, businessId = _this$props$business.id, businessType = _this$props$business.type, destinationEmail = _this$props.destinationEmail;
              locationId = formData.location, email = formData.email, firstName = formData.firstName, lastName = formData.lastName, phone = formData.phone, guestsNumber = formData.guestsNumber, comments = formData.comments, reservationDate = formData.reservationDate, reservationTime = formData.reservationTime;
              payload = {
                email: email,
                first_name: firstName,
                last_name: lastName,
                party_size: guestsNumber,
                phone: phone,
                comments: comments,
                destination_email: destinationEmail,
                datetime: stringifyReservationDate(reservationDate, reservationTime)
              };
              _context.next = 11;
              return requestReservation({
                businessId: businessId,
                businessType: businessType,
                locationId: locationId
              }, payload, recaptchaToken);
            case 11:
              this.resetForm();
              this.displayMessage('Reservation submitted successfully.');
              _context.next = 19;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);
              this.displayMessage('Unknown error submitting reservation form. Please try again later.', true);
              throw _context.t0;
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 15]]);
      }));
      function onSubmit(_x, _x2) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "resetForm",
    value: function resetForm() {
      var locations = this.props.locations;
      var primaryLocation = getPrimaryLocation(locations);
      var timezone = primaryLocation.timezone,
        id = primaryLocation._id;
      var reservationDate = getDefaultReservationDate(timezone);
      this.setState({
        formData: {
          location: id,
          reservationDate: reservationDate
        }
      });
    }
  }, {
    key: "displayMessage",
    value: function displayMessage(messageToDisplay) {
      var _this2 = this;
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$clearTimeout = _ref2.clearTimeout,
        clearTimeout = _ref2$clearTimeout === void 0 ? true : _ref2$clearTimeout;
      this.setState({
        message: messageToDisplay,
        error: isError
      });
      if (clearTimeout) {
        setTimeout(function () {
          _this2.setState({
            message: ''
          });
        }, 5000);
      }
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      var formData = this.state.formData;
      return !getValidationMessage(formData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        locations = _this$props2.locations,
        hideRecaptchaNotice = _this$props2.hideRecaptchaNotice;
      var _this$state = this.state,
        message = _this$state.message,
        error = _this$state.error,
        formData = _this$state.formData;
      var locationId = formData.location;
      var _getPrimaryLocation = getPrimaryLocation(locations),
        phoneNumber = _getPrimaryLocation.phoneNumber;
      var numberOfGuestsOptions = getNumberOfGuestsOptions();
      var multipleLocations = locations.length >= 2;
      var location;
      if (!locationId) {
        location = getPrimaryLocation(locations);
      } else {
        location = locations.find(function (_ref3) {
          var id = _ref3._id;
          return locationId === id;
        });
      }
      return /*#__PURE__*/React.createElement(ReSubmitRecaptchaForm, {
        title: "Request a Reservation",
        className: "reservations-form",
        onSubmit: this.onSubmit,
        postSubmissionMessage: "Thanks! We'll call or email you to finalize your reservation request.",
        postSubmissionButtonMessage: "Request Another Reservation",
        action: ActionName.SUBMIT_RESERVATION_FORM,
        hideRecaptchaNotice: hideRecaptchaNotice
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
        widths: "equal"
      }, /*#__PURE__*/React.createElement(Form.Input, {
        required: true,
        label: "Reservation Date",
        value: formData.reservationDate || '',
        name: "reservationDate",
        onChange: function onChange(e, target) {
          _this3.onChange(e, target);
          _this3.setState(function (prevState) {
            return {
              formData: _objectSpread(_objectSpread({}, prevState.formData), {}, {
                reservationTime: null
              })
            };
          });
        },
        type: "date",
        min: getDefaultReservationDate(location.timezone),
        max: getDefaultReservationMaxDate()
      }), /*#__PURE__*/React.createElement(ReservationTimeSelect, {
        location: location,
        value: formData.reservationTime,
        onChange: this.onChange,
        reservationDate: formData.reservationDate
      })), /*#__PURE__*/React.createElement(Form.Group, {
        widths: multipleLocations ? 'equal' : 16
      }, multipleLocations && /*#__PURE__*/React.createElement(LocationsSelect, {
        locations: locations,
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Form.Select, {
        required: true,
        label: "Number of Guests",
        name: "guestsNumber",
        value: formData.guestsNumber || '',
        placeholder: "Select",
        options: numberOfGuestsOptions,
        onChange: this.onChange,
        className: "number-of-guests-select"
      })), /*#__PURE__*/React.createElement(Form.Group, {
        widths: "equal"
      }, /*#__PURE__*/React.createElement(Form.Input, {
        required: true,
        label: "First Name",
        placeholder: "Name Name",
        value: formData.firstName || '',
        name: "firstName",
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Form.Input, {
        required: true,
        label: "Last Name",
        placeholder: "Last Name",
        value: formData.lastName || '',
        name: "lastName",
        onChange: this.onChange
      })), /*#__PURE__*/React.createElement(Form.Group, {
        widths: "equal"
      }, /*#__PURE__*/React.createElement(Form.Input, {
        required: true,
        type: "email",
        label: "Email",
        placeholder: "you@gmail.com",
        value: formData.email || '',
        name: "email",
        onChange: this.onChange
      }), /*#__PURE__*/React.createElement(Form.Input, {
        label: "Mobile Phone Number",
        required: true
      }, /*#__PURE__*/React.createElement(PhoneInput, {
        required: true,
        onChange: this.onChange,
        name: "phone",
        value: formData.phone || ''
      }))), /*#__PURE__*/React.createElement(Form.TextArea, {
        label: "Additional Comments",
        value: formData.comments || '',
        name: "comments",
        placeholder: "Any special occasion you are celebrating?",
        onChange: this.onChange
      }), message && /*#__PURE__*/React.createElement(Message, {
        content: message,
        negative: error
      }), /*#__PURE__*/React.createElement(Form.Button, {
        disabled: !this.isFormValid(),
        primary: true
      }, "Request Reservation"), /*#__PURE__*/React.createElement("p", {
        className: "disclaimer-text"
      }, "Disclaimer: Submitting this request does not confirm a reservation, we will respond to you via email or phone to discuss your request. You can also call us directly at", ' ', /*#__PURE__*/React.createElement(Phone, {
        phone: phoneNumber
      }), ".")));
    }
  }]);
  return ReservationForm;
}(React.Component);
export { ReservationForm as default };
ReservationForm.defaultProps = defaultProps;